import { render, staticRenderFns } from "./LuExciseTransactionTypeGrid.vue?vue&type=template&id=0ed96cf5&"
import script from "./LuExciseTransactionTypeGrid.vue?vue&type=script&lang=js&"
export * from "./LuExciseTransactionTypeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports